// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://bscscan.com/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://bscscan.com/address/0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6
export const PROTOCOL_GUARDIAN = '0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6';

// https://bscscan.com/address/0x39EBFfc7679c62Dfcc4A3E2c09Bcb0be255Ae63c
export const PROXY_ADMIN = '0x39EBFfc7679c62Dfcc4A3E2c09Bcb0be255Ae63c';

// https://bscscan.com/address/0x3b56998Ec06477704622ca8e2eA1b4db134cec32
export const CREATE_3_FACTORY = '0x3b56998Ec06477704622ca8e2eA1b4db134cec32';

// https://bscscan.com/address/0x51Bd3d6011Dd0BD88Ee1bEA1a67be799A6A09D79
export const AAVE_CL_ROBOT_OPERATOR = '0x51Bd3d6011Dd0BD88Ee1bEA1a67be799A6A09D79';

// https://bscscan.com/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://bscscan.com/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://bscscan.com/address/0xAA43203167317DeeF8288095C44b84a686918d2E
export const APE_SAFE = '0xAA43203167317DeeF8288095C44b84a686918d2E';

// https://bscscan.com/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://bscscan.com/address/0x6046A62a80a2c19A0De91063602ce90533c62ae1
export const REWARD_STEWARD = '0x6046A62a80a2c19A0De91063602ce90533c62ae1';

// https://bscscan.com/address/0x115E662Fa3f0b83014eB3f6F86F3D94BeC5eB411
export const AGENT_HUB = '0x115E662Fa3f0b83014eB3f6F86F3D94BeC5eB411';

// https://bscscan.com/address/0x78C2eCf3Ad48F90350f42EB338675cA1b31a7f11
export const AGENT_HUB_AUTOMATION = '0x78C2eCf3Ad48F90350f42EB338675cA1b31a7f11';

// https://bscscan.com/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 56;
